export const Areas = [
    /*
    # # # # # # # # # # # # # # # #
    . . . . . . . . . . . x x x . #
    . # x # x # . # . # . # x # . #
    . . x x x . . x x x x x x . . #
    . # . # . # . # . # . # . # . #
    . . . . . . . . . . . . . . . #
    . # . # . # . # x # . # . # . #
    . . x x x . . . x . . . . . . #
    . # x # x # . # x # . # x # . #
    . . x x x . . . . . . x x x . #
    . # . # . # . # . # . # x # . #
    . . . . . . . . . . . . . . . #
    . # . # . # x # x # x # . # x #
    . . . . . . x x x x x ! . . x #
    . # . # . # x # x # x # . # x #
    . . . . . . . . . . . . . . . #
    */
    {
        cells: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 0, 1, 0, 1, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 2, 1, 0, 1, 0, 0, 2, 2, 2, 0, 0, 2, 2, 2, 2, 2, 2, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 0, 2, 2, 2, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 1, 0, 1, 2, 1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0, 1, 0, 0, 2, 2, 2, 0, 0, 0, 0, 0, 0, 2, 2, 2, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 2, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 2, 1, 2, 1, 2, 1, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 3, 0, 0, 2, 1, 0, 1, 0, 1, 0, 1, 2, 1, 2, 1, 2, 1, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
        size: 16
    },
];
//# sourceMappingURL=Areas.js.map